import { Modal } from 'react-bootstrap'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { Dispatch, SetStateAction } from 'react'
import { useThemeMode } from '../../../../_metronic/partials'

export const DeleteConfirmationModal = ({
  setDeleteShowModal,
  showDeleteModal,
  onDeleteSubmit,
  deleteLoading,
  header,
  paragraph,
}: {
  setDeleteShowModal: Dispatch<SetStateAction<boolean>>
  showDeleteModal: boolean
  onDeleteSubmit: any
  deleteLoading: boolean
  header: string
  paragraph: string
}) => {
  const { mode } = useThemeMode()
  return (
    <>
      <div className=' '>
        <Modal
          show={showDeleteModal}
          onHide={() => setDeleteShowModal(false)}
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Header closeButton>
            <h2>{header}</h2>
          </Modal.Header>
          <Modal.Body className='container'>
            <p>{paragraph}</p>
          </Modal.Body>
          <Modal.Footer>
            <BasicButton
              height='44px'
              border='none'
              color={mode === 'dark' ? '#2b2b40' : '#F5F8FA'}
              textColor='#7E8299'
              padding='12px 16px'
              onClick={() => {
                setDeleteShowModal(false)
              }}
              buttonText='Cancel'
              minWidth={56} />

            <BasicButton
              height='44px'
              border='1px solid #4776E6'
              color='#4776E6'
              textColor='white'
              padding='12px 24px'
              onClick={() => {
                onDeleteSubmit()
              }}
              buttonText='Confirm Delete'
              minWidth={56}
              loading={deleteLoading}
              disabled={deleteLoading} />
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
